import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="delivery-window"
// Presentational toggle for the pipeline delivery-window editor; the server
// (Pipelines::DeliveryWindowParams) owns the translation to run_at_minutes.
export default class extends Controller {
  static targets = ["mode", "times", "list"];

  connect() {
    this.modeChanged();
  }

  modeChanged() {
    const checked = this.modeTargets.find((el) => el.checked);
    const specific = checked && checked.value === "specific_times";
    if (this.hasTimesTarget) this.timesTarget.classList.toggle("hidden", !specific);
  }

  addTime() {
    const input = document.createElement("input");
    input.type = "time";
    input.step = "300";
    input.name = "pipeline[delivery_times][]";
    input.className = "block rounded-md border-gray-300 shadow-sm sm:text-sm";
    this.listTarget.appendChild(input);
  }
}
